import { render } from "./OuG45.vue?vue&type=template&id=166bc831"
import script from "./OuG45.vue?vue&type=script&lang=js"
export * from "./OuG45.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__